// Detecta si la URL tiene 'www.' o no y devuelve la base correcta
const getBaseURL = () => {
    const currentHost = window.location.hostname; // Obtiene el host actual
    if (currentHost.includes('localhost')) {
        return 'http://localhost:4242/';
    } else if (currentHost.includes('cesecouaq.mx')) {
        return 'https://cesecouaq.mx/';
    } else {
        return 'https://uaq.kexe.mx/';
    }
};

const baseURL = getBaseURL(); // Obtiene la URL base correcta

export default baseURL;
